import useSWR from 'swr';

import { fetchRatingForecast } from 'common/api/kbyg';
import type { RatingForecastResponse } from 'types/ratingForecast';

const FIVE_MINUTES_IN_MS = 60 * 5000;

type FetchParams = {
  spotId: string;
  days: number;
  intervalHours: number;
};

const useFetchRatings = (spotId: string) => {
  const args = { spotId, days: 1, intervalHours: 1 };

  const fetcher = ({ spotId: spotIdArg, days, intervalHours }: FetchParams) =>
    fetchRatingForecast({
      id: spotIdArg,
      days,
      intervalHours,
      corrected: true,
    }) as Promise<RatingForecastResponse>;

  const {
    data,
    error,
    isLoading: loading,
  } = useSWR<RatingForecastResponse>(args, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 0,
    dedupingInterval: FIVE_MINUTES_IN_MS,
  });

  return { data, error, loading };
};

export default useFetchRatings;
